/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamDataPlatforms
 */
export interface OWGameSteamDataPlatforms {
    /**
     * 
     * @type {boolean}
     * @memberof OWGameSteamDataPlatforms
     */
    windows?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OWGameSteamDataPlatforms
     */
    mac?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OWGameSteamDataPlatforms
     */
    linux?: boolean;
}

/**
 * Check if a given object implements the OWGameSteamDataPlatforms interface.
 */
export function instanceOfOWGameSteamDataPlatforms(value: object): value is OWGameSteamDataPlatforms {
    return true;
}

export function OWGameSteamDataPlatformsFromJSON(json: any): OWGameSteamDataPlatforms {
    return OWGameSteamDataPlatformsFromJSONTyped(json, false);
}

export function OWGameSteamDataPlatformsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamDataPlatforms {
    if (json == null) {
        return json;
    }
    return {
        
        'windows': json['windows'] == null ? undefined : json['windows'],
        'mac': json['mac'] == null ? undefined : json['mac'],
        'linux': json['linux'] == null ? undefined : json['linux'],
    };
}

export function OWGameSteamDataPlatformsToJSON(json: any): OWGameSteamDataPlatforms {
    return OWGameSteamDataPlatformsToJSONTyped(json, false);
}

export function OWGameSteamDataPlatformsToJSONTyped(value?: OWGameSteamDataPlatforms | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'windows': value['windows'],
        'mac': value['mac'],
        'linux': value['linux'],
    };
}

